import { render } from "./ShieldFailIcon.vue?vue&type=template&id=cb7d9a9c"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/ShieldFailIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cb7d9a9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cb7d9a9c', __exports__)) {
    api.reload('cb7d9a9c', __exports__)
  }
  
  module.hot.accept("./ShieldFailIcon.vue?vue&type=template&id=cb7d9a9c", () => {
    api.rerender('cb7d9a9c', render)
  })

}


export default __exports__